
// import {setGetCashbackListAction} from '../action';
// import { getCashback } from '../api/getCashback';
import { postCashback } from '../api/postCashback';

export const setPostCashback = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postCashback(params);
            alert('Выдано')
            // if (data.status === 'success') {
            //     dispatch(setGetCashbackListAction({
            //         data: data.data,
            //         countPage: data.allPage
            //     }));           
            // }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}